import clsx from 'clsx'
import React, { FC } from 'react'

import { CatalogBrandsFilterValue } from '@/entities/catalog-brands/types/type'

import { CheckboxGroup } from '@/shared/ui/checkbox'

import cls from './checkbox-list.module.scss'

interface CheckboxListProps {
	items: CatalogBrandsFilterValue[]
	name: string
	open?: boolean
	isDisabled?: boolean
}

export const CheckboxList: FC<CheckboxListProps> = ({ items, name, open, isDisabled }) => {
	const adaptedValue = items.map(({ VALUE, CHECKED, ELEMENT_COUNT }, index) => ({
		label: VALUE.toString(),
		value: VALUE,
		checked: CHECKED,
		disabled: !ELEMENT_COUNT,
		isHide: index > 4 && !open
	}))

	return (
		<div className={clsx(cls.root)}>
			<CheckboxGroup name={name} items={adaptedValue} isDisabled={isDisabled} />
		</div>
	)
}
